<template lang="pug">
    draggable(v-model="model.sessions")
        div.meditation(v-for="item in model.sessions" :key="item.id")
            div  {{ item.title }}
            div
                v-icon(color="white") unfold_more
</template>

<script>
    import draggable from 'vuedraggable';
    import { mapFields } from 'vuex-map-fields';

    export default {
        components: {
            draggable
        },
        computed: {
            ...mapFields('programs', {
                model: 'program'
            })
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .meditation
        display: flex
        align-items: center
        justify-content: space-between
        padding: 5px 15px
        margin: 5px 0
        border: 1px solid rgba($theme.white, 0.5)
        background: $theme.primary
</style>
